import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

export const heroSwiper = (() => {
  const swipers = document.querySelectorAll(".heroSwiper");

  swipers.forEach((swiperEl) => {
    const id = swiperEl.getAttribute('data-id');
    const swiper = new Swiper(`.heroSwiper-${id}`, {
      allowTouchMove: false,
      slidesPerView: "auto",
      spaceBetween: 24,
      modules: [Pagination],
      direction: 'horizontal',

      pagination: {
        el: `.heroSwiper-${id}-pagination`,
        clickable: true,
        renderBullet: function (index, className) {
          console.log(index, className);
          const slides = document.querySelectorAll(`.heroSwiper-${id} .swiper-slide`);
          const heading = slides[index].querySelector('.subpagehero-heading').textContent.trim();

          return `
          <div class="${className}">
            <span class="bullet-heading">${heading}</span>
            <span class="bullet-line"></span>
          </div>
        `;
        },
      },

      navigation: {
        nextEl: `.heroSwiper-${id}-button-next`,
        prevEl: `.heroSwiper-${id}-button-prev`,
      },
    });
  });

  // Function to check if .subpagehero contains .btn--alert and scroll to the bottom
  const checkHeroButtonAndScroll = () => {
    const heroSection = document.querySelector('.subpagehero');
    if (heroSection) {
      const alertButton = heroSection.querySelector('.btn--alert');
      if (alertButton) {
        alertButton.addEventListener('click', (e) => {
          e.preventDefault();
          window.scrollTo({
            top: document.body.scrollHeight,
            behavior: 'smooth'
          });
        });
      }
    }
  };

  // Run the function after DOM content is fully loaded
  document.addEventListener('DOMContentLoaded', checkHeroButtonAndScroll);
})();
